import { lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import Seo from "@/components/Seo";
import HomeHero from "@/components/home/HomeHero";
import FounderToolkitQuiz from "@/components/FounderToolkitQuiz";
import { useToolkitQuiz } from "@/hooks/useToolkitQuiz";

// Lazy-load below-the-fold sections to shrink initial bundle and improve LCP/FCP
const HomeStats = lazy(() => import("@/components/home/HomeStats"));
const AnyaStory = lazy(() => import("@/components/home/AnyaStory"));
const HowItWorks = lazy(() => import("@/components/home/HowItWorks"));
const ToolsTeaser = lazy(() => import("@/components/home/ToolsTeaser"));

const Newsletter = lazy(() => import("@/components/home/Newsletter"));
const HomeFooter = lazy(() => import("@/components/home/HomeFooter"));

const Home = () => {
  const { open, close } = useToolkitQuiz();
  return (
    <div className="min-h-screen bg-background">
      <Seo
        title="AI Co-Founder for Startups — The Founder's Playbook"
        description="Build your startup solo with an AI co-founder — 80+ prompts, a 36-fund library, $2.1M+ in free credits. Idea to launch, no team or budget needed."
        path="/"
      />
      <Navbar />
      <main>
        <HomeHero />
        <Suspense fallback={null}>
          <HomeStats />
          <AnyaStory />
          <HowItWorks />
          <ToolsTeaser />
          <Newsletter />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <HomeFooter />
      </Suspense>
      <FounderToolkitQuiz open={open} onClose={close} />
    </div>
  );
};

export default Home;
